module.exports = __webpack_public_path__ + "img/bus-fill-orange.ed301942.svg";